module.exports = __webpack_public_path__ + "static/media/giphy-9.d51474f5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-9.gif
// module id = 180
// module chunks = 0